import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap'
import {
  MarkSignatureFormAsViewedResponse,
  NodeSignatureFormsEntry,
} from '../../../types/signatureFormsEntriesApi'
import moment from 'moment'
import {prependBackendUrl} from '../../../gql/client'
import {MARK_SIGNAFTURE_FORMS_AS_VIEWED} from '../../../gql/mutations/signatureFormsMutations'
import {useMutation} from '@apollo/client'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'

export const ModalPreview: React.FC<{
  onClose: () => void
  isOpen: boolean
  info: NodeSignatureFormsEntry
  refetch?: () => void
}> = ({info, isOpen, onClose, refetch}) => {
  const [gqlAddLogEntry, {data: dateEntryLog, loading: logadingEntryLog, error: erroEntryLog}] =
    useMutation<MarkSignatureFormAsViewedResponse>(MARK_SIGNAFTURE_FORMS_AS_VIEWED)

  useEffect(() => {
    if (isOpen && info.id) {
      gqlAddLogEntry({
        variables: {
          token: info.token, // Ajusta según tu mutation
        },
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, info.token])

  useEffect(() => {
    if (!dateEntryLog) return

    console.log(JSON.stringify(dateEntryLog))
  }, [gqlAddLogEntry, dateEntryLog])

  useEffect(() => {
    if (erroEntryLog) toast.error(`Error: ${erroEntryLog.message}`)
  }, [erroEntryLog])

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>{info.signatureForm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor: '#f2f3f8'}}>
        {info.signedPdf && (
          <div className='mb-3 d-flex justify-content-end'>
            <a
              className='btn btn-outline-primary'
              href={prependBackendUrl(info.signedPdfUrl)}
              target='_blank'
              rel='noopener noreferrer'
              download
            >
              Download Signed PDF
            </a>
          </div>
        )}
        <Card>
          <Card.Body>
            <Form.Group>
              <Form.Label>Form Content</Form.Label>
              <div
                style={{
                  border: '1px solid #ced4da',
                  borderRadius: '0.375rem',
                  background: '#fff',
                  minHeight: 120,
                  padding: 12,
                  overflowX: 'auto',
                  width: '100%',
                }}
                dangerouslySetInnerHTML={{__html: info.renderedHtml || ''}}
              />
            </Form.Group>
            {info.signatureImage && (
              <div className='mt-3 text-center'>
                <Form.Label>Signature Image</Form.Label>
                <div>
                  <img
                    src={prependBackendUrl(info.signatureImageUrl)}
                    alt='Signature'
                    style={{
                      maxHeight: 150,
                      maxWidth: '100%',
                      border: '1px solid #ced4da',
                      borderRadius: '0.375rem',
                      padding: '6px',
                      background: '#fff',
                    }}
                  />
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
        <Card className='cards-logs-enties'>
          <Card.Header>
            <h3>Signature trail log</h3>
          </Card.Header>
          <Card.Body>
            <Table striped hover responsive className='mb-0'>
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>Action</th>
                  <th>Contact</th>
                  <th>User</th>
                  <th>IP</th>
                  <th>Browser</th>
                  <th>Mobile device</th>
                </tr>
              </thead>
              {logadingEntryLog ? (
                <Spinner animation='border' size='sm' className='me-2' />
              ) : (
                <>
                  {dateEntryLog && dateEntryLog.markSignatureFormAsViewed ? (
                    <>
                      <tbody>
                        {dateEntryLog.markSignatureFormAsViewed.logs &&
                        dateEntryLog.markSignatureFormAsViewed.logs.length > 0 ? (
                          dateEntryLog.markSignatureFormAsViewed.logs.map((log, index) => (
                            <tr key={index}>
                              <td>{moment(log.created).format('YYYY-MM-DD HH:mm:ss')}</td>
                              <td>{log.action}</td>
                              <td>{log.contact ?? '-'}</td>
                              <td>
                                {log.user ? `${log.user.firstName} ${log.user.lastName}` : '-'}
                              </td>
                              <td>{log.ipAddress ?? '-'}</td>
                              <td>{log.browser ?? '-'}</td>
                              <td>{log.isMobile ? 'Yes' : 'No'}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              No logs available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </>
                  ) : (
                    <tbody>
                      {info.logs && info.logs.length > 0 ? (
                        info.logs.map((log, index) => (
                          <tr key={index}>
                            <td>{moment(log.created).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{log.action}</td>
                            <td>{log.contact ?? '-'}</td>
                            <td>{log.user ? `${log.user.firstName} ${log.user.lastName}` : '-'}</td>
                            <td>{log.ipAddress ?? '-'}</td>
                            <td>{log.browser ?? '-'}</td>
                            <td>{log.isMobile ? 'Yes' : 'No'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            No logs available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </>
              )}
            </Table>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
